import { Component, OnInit, Input, Output, EventEmitter, HostListener, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { ArticulosGeneral, EcommerceGenericoService, RemplazosMMax, } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { CheckboxCategorias, CheckboxSubcategoria, } from '../etc/categoria-checkbox.interface';
import { MarianomGeneral } from '../marianom-general.service';
import { ArticulosEcommerce } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/articulos-ecommerce.interface';
import { ComboPromo } from 'projects/mariano-max/src/app/core/ecommerce-generico/class/combo-promo.class';
import { PorcentajePromo } from 'projects/mariano-max/src/app/core/ecommerce-generico/class/porcentaje-promo.class';

@Component({
  selector: 'productos-view',
  templateUrl: './productos-view.component.html',
  styleUrls: ['./productos-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductosViewComponent implements OnInit {
  @Input() articulo: ArticulosGeneral;
  @Input() mode: string;
  @Output() closeGap: EventEmitter<boolean>;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.width = window.innerWidth;
  }

  constructor(
    private serv: MarianomGeneral,
    private route: ActivatedRoute,
    private modal: ModalService,
    public genServ: EcommerceGenericoService,
    private cdr: ChangeDetectorRef) {
      this.mode = this.mode || 'normal';
      this.closeGap = new EventEmitter();
    }

  async ngOnInit(): Promise<void> {
    if (this.mode === 'detalletrakin') {
    }

    this.width = window.innerWidth;

    this.genServ.returnUsaBultos().subscribe(data => {
      this.usaBultos = (data || 'N').toString().trim();
      this.inicializarModoSumador();
      this.cdr.markForCheck();
    });

    this.genServ.returnUsaLista().subscribe(data => {
      this.usaLista = (data || 'N').toString().trim();
      this.inicializarModoSumador();
      this.cdr.markForCheck();
    });

    this.genServ.getAvisoArticulosSucursalCargados().subscribe(() => {
      this.inicializarModoSumador();
      this.cdr.markForCheck();
    });
    
    this.genServ.getObservableSeAgregaronItemsAlCarrito().subscribe(() => {
      this.inicializarModoSumador();
      this.cdr.markForCheck();
    });

    this.inicializarModoSumador();

    // Solo procesar la imagen si hay un artículo (evita crash en modo skeleton)
    if (this.articulo) {
      if (!this.articulo.getImgDownload()) {
        await this.genServ.bajarImagen(this.articulo).toPromise().then(
          () => {
            this.articulo.setImgDownload(true);
            this.cdr.markForCheck();
          }
        );
      }
    }

    this.genServ.getReemplazosProvider().subscribe(
      data => {
        this.misremplasos = data;
      }
    );
  }

  iraSeach() {
    this.closeGap.emit(true);
  }

  iraSeachmobile() {
    this.serv.navigator.goSearch(this.route);
  }

  categoriaSelec(reemplazoModificado: any) {
    this.articulo.getRemplazos().forEach(
      reemplazoObj => {
        if (reemplazoObj.idcss === reemplazoModificado[0].idcss) {
          reemplazoObj.activo = reemplazoModificado[0].activo
        }
      }
    );
  }

  eliminar() {
    this.genServ.eliminarPromos(this.articulo);
    this.genServ.sincronizarCarritoFrontyBack();
  }

  seleccionarUnidades() {
    this.modoSumador = 'unidades';
    this.sumaevent(1);
  }

  seleccionarBultos() {
    this.modoSumador = 'bultos';
    this.sumaeventBultos(1);
  }

  sumaevent(numero: number) {
    
    if (numero > 0) {
      if (this.articulo.getCantidad() == 0) {
        if (!this.serv.isloged()) {
          this.serv.abrirModalLogin();
        }
        else {
          this.articulo.agregarCantidad(numero);
          this.serv.articuloAmostrar(this.articulo);
        }

      }
      else {
        if (this.articulo.getCantidadMaxima() > this.articulo.getCantidad() || numero < 0 || this.articulo.getCantidadMaxima() == 0 || (this.articulo.getCantidadMaxima() > numero && numero != 1)) {
          if (this.articulo.getCantidadMaxima() > numero || this.articulo.getCantidadMaxima() == 0) {
            this.articulo.agregarCantidad(numero);
            this.serv.articuloAmostrar(this.articulo);
          }
          else {
            this.modal.open('modal-max-art');
          }
        }
        else {
          this.modal.open('modal-max-art');
        }
      }
    }
    else {
      if (this.articulo.getCantidadMaxima() > this.articulo.getCantidad() || numero < 0 || this.articulo.getCantidadMaxima() == 0 || (this.articulo.getCantidadMaxima() > numero && numero != 1)) {
        if (this.articulo.getCantidad() + numero >= 0 || this.articulo.getCantidadMaxima() > numero) {
          this.articulo.agregarCantidad(numero);
        }
        else {
          this.modal.open('modal-max-art');
        }
      }
      else {
        this.modal.open('modal-max-art');
      }
    }
    if (this.articulo.getCantidad() === 0 &&
      this.articulo.getCantidadBultos() === 0) {
      this.modoSumador = 'inicio';
    }

    this.genServ.sincronizarCarritoFrontyBack();
    this.articulo.operacionesExtras();
  }

  sumaeventBultos(numero: number) {
    if (numero > 0) {
      if (!this.serv.isloged()) {
        this.serv.abrirModalLogin();
      } else {
        this.articulo.agregarBultos(numero);
        this.serv.articuloAmostrar(this.articulo);
      }
    } else {
      this.articulo.agregarBultos(numero);
      this.serv.articuloAmostrar(this.articulo);
    }

    if (this.articulo.getCantidad() === 0 &&
    this.articulo.getCantidadBultos() === 0) {
      this.modoSumador = 'inicio';
    }

    this.genServ.sincronizarCarritoFrontyBack();
    this.articulo.operacionesExtras();
  }

  getCantidadParaMonto() {
    if (this.permiteBultosArticulo() && this.articulo.getCantidadBultos() > 0) {
      return this.articulo.getCantidadBultos() * this.articulo.getUnidadesPorBulto();
    }

    return this.articulo.getCantidad();
  }

  getPrecioCalculadoCarrito() {
    const precio = this.articulo.isdeOferta()
      ? this.articulo.getPrecioOferta()
      : this.articulo.getPrecio();
    return precio * this.getCantidadParaMonto();
  }

  /**
   * Un Combo involucra varios artículos a la vez, así que
   * misPromo[0].getPrecioCalculado() (precio TOTAL del combo) no representa
   * el renglón de este artículo puntual. Para estas líneas se muestra el
   * artículo a su precio real; el descuento del combo se ve en el total.
   */
  esPromoCombo(): boolean {
    return !!(this.articulo.misPromo && this.articulo.misPromo[0] instanceof ComboPromo);
  }

  /**
   * Con promos de Porcentaje por Categoria, una misma instancia de promo
   * puede estar pegada a muchos artículos distintos (uno por producto de
   * la categoría). misPromo[0].getPrecioCalculado() calcula en base al
   * primer artículo que resolvió la promo (articulo1), no en base a ESTE
   * artículo puntual, así que da un precio compartido/incorrecto para
   * cualquier otro artículo de la categoría. articulo.getPrecioCalculado()
   * en cambio sí es por-artículo (usa this.modificacionPrecio, que
   * preconPromo() ya acumula correctamente por artículo).
   */
  esPromoPorcentaje(): boolean {
    return !!(this.articulo.misPromo && this.articulo.misPromo[0] instanceof PorcentajePromo);
  }

  /**
   * Precio de línea a mostrar cuando articulo.getCantidad() ya completó un
   * múltiplo de cantidadenPromo(). No se puede usar misPromo[0].getPrecioCalculado()
   * a ciegas:
   * - Porcentaje: da el precio del primer artículo que resolvió la promo
   *   (articulo1), no el de ESTE artículo -> se usa articulo.getPrecioCalculado().
   * - Combo: da this.monto, el precio TOTAL fijo del combo entero, no la
   *   parte de este artículo -> se muestra el precio real del artículo sin
   *   descuento (el ahorro del combo se ve aparte, como fila de "Descuento"
   *   en lista-productos-view).
   * - Monto/Diferencia/NxM: sin cambios, siguen usando el valor de la promo.
   */
  precioLineaConPromo(): number {
    if (this.esPromoPorcentaje()) {
      return (this.articulo as ArticulosEcommerce).getPrecioCalculado();
    }
    if (this.esPromoCombo()) {
      return this.getPrecioCalculadoCarrito();
    }
    return this.articulo.misPromo[0].getPrecioCalculado();
  }

  inicializarModoSumador() {
    if (!this.articulo) {
      this.modoSumador = 'inicio';
      return;
    }

    if (this.articulo.getCantidadBultos() > 0 && this.permiteBultosArticulo()) {
      this.modoSumador = 'bultos';
      return;
    }

    if (this.articulo.getCantidad() > 0) {
      this.modoSumador = 'unidades';
      return;
    }

    this.modoSumador = 'inicio';
  }

  openArtModal() {
    this.modal.open('modal-articulo');
  }

  artOpened(art: ArticulosGeneral) {
    this.genServ.setearArticuloParaModal(art);
  }

  obtenerTipoUnidadDeEtiquetaDeArticulo(articulo: ArticulosGeneral) {
    if (articulo.getOtrosPrecios().length === 0) {
      return 'Un';
    }
    let unidad: string = articulo.getOtrosPrecios().slice(articulo.getOtrosPrecios().indexOf('x'));
  }

  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio()
  }

  muestraBultosGlobal(): boolean {
    return this.usaBultos === 'S' || this.usaBultos === 'L';
  }

  permiteBultosArticulo(): boolean {
    if (!this.articulo) {
      return false;
    }
  
    if (this.articulo.getUnidadesPorBulto() <= 1) {
      return false;
    }
  
    if (this.usaBultos === 'S') {
      return true;
    }
  
    if (this.usaBultos === 'L') {
      return this.usaLista === 'S';
    }
  
    return false;
  }
  
  abrirModalObservacion(): void {
    console.log('ABRIENDO MODAL OBS PARA:', this.articulo);

    this.genServ.setArticuloObservacion(this.articulo as ArticulosEcommerce);
    this.modal.open('modal-agregar-observacion');
  }

  tieneBultosCargados(): boolean {
    return !!this.articulo &&
      !!this.articulo.getCantidadBultos &&
      this.articulo.getCantidadBultos() > 0;
  }
  
  getUnidadesEquivalentesBultos(): number {
    if (!this.tieneBultosCargados()) {
      return 0;
    }
  
    return this.articulo.getCantidadBultos() * this.articulo.getUnidadesPorBulto();
  }

  modoSumador: 'inicio' | 'selector' | 'unidades' | 'bultos' = 'inicio';
  usaBultos: string = 'N';
  usaLista: string = 'N';
  misremplasos: RemplazosMMax[];
  remplazoselct: RemplazosMMax;
  gaseosas: CheckboxCategorias[];
  preload: boolean;
  width;
}
